import { z } from 'zod'

export const CRM_DRIP_SEQUENCE_CONTRACT_VERSION = '1.0.0' as const

const rowSchema = z.record(z.unknown())
const optionalQueryString = z.preprocess(
  (value) => (typeof value === 'string' ? value : undefined),
  z.string().optional(),
)

export const crmDripSequenceQuerySchema = z.object({
  orgId: optionalQueryString,
  org_id: optionalQueryString,
  limit: optionalQueryString,
  status: optionalQueryString,
}).passthrough()

export const crmDripSequenceResponseSchema = z.object({
  contract_version: z.literal(CRM_DRIP_SEQUENCE_CONTRACT_VERSION),
  sequence: rowSchema,
  replayed: z.boolean().optional(),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmDripSequenceListResponseSchema = z.object({
  contract_version: z.literal(CRM_DRIP_SEQUENCE_CONTRACT_VERSION),
  sequences: z.array(rowSchema),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmDripStepResponseSchema = z.object({
  contract_version: z.literal(CRM_DRIP_SEQUENCE_CONTRACT_VERSION),
  step: rowSchema,
  outcome: z.enum(['created', 'reused', 'restored']),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmDripStepListResponseSchema = z.object({
  contract_version: z.literal(CRM_DRIP_SEQUENCE_CONTRACT_VERSION),
  steps: z.array(rowSchema),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmDripSequenceReadErrorEnvelopeSchema = z.object({
  contract_version: z.string().min(1),
  error: z.object({ code: z.string().min(1), message: z.string().min(1), reference: z.string().min(1) }).passthrough(),
}).passthrough()

export type CrmDripSequenceQuery = z.infer<typeof crmDripSequenceQuerySchema>
export type CrmDripSequenceResponse = z.infer<typeof crmDripSequenceResponseSchema>
export type CrmDripSequenceListResponse = z.infer<typeof crmDripSequenceListResponseSchema>
export type CrmDripStepResponse = z.infer<typeof crmDripStepResponseSchema>
export type CrmDripStepListResponse = z.infer<typeof crmDripStepListResponseSchema>
export type CrmDripSequenceReadErrorEnvelope = z.infer<typeof crmDripSequenceReadErrorEnvelopeSchema>
